
export const SentryEnvironment = {
   SENTRY_DSN: "null",
   SENTRY_RELEASE: "null"
};
